module.exports = __webpack_public_path__ + "img/s2P8.55ef81fd.png";